





































import {
  computed, defineComponent, Ref, ref, watch,
} from '@vue/composition-api';
import { LoremIpsum } from 'lorem-ipsum';
import useHandleDrawer from '@/components/composers/useHandleDrawer';
import store from '@/store/index';
import ApiService from '@/services/ApiService';
import { IPost } from '@/interfaces/IPost';

const ArticlesOverlay: object = defineComponent({
  name: 'ArticlesOverlay',
  setup() {
    const handleDrawer = useHandleDrawer();

    const lorem = new LoremIpsum({
      sentencesPerParagraph: {
        max: 8,
        min: 4,
      },
      wordsPerSentence: {
        max: 16,
        min: 4,
      },
    });

    const selectedPageId: Ref<number> = ref(-1);

    const pages: Ref<any> = computed(() => store.state.posts);

    const selectedPage: Ref<IPost> = ref(() => {});

    const changeSelectedPage = (idPage: number) => {
      selectedPageId.value = idPage;
      ApiService.fetchPostDetails(idPage)
        .then((res) => {
          selectedPage.value = res.data;
          selectedPage.value.htmlContent = selectedPage.value.htmlContent
            .replace(/\\r\\n/g, '')
            .replace(/\\"/g, '"')
            .replace(/\\t/g, '');
        });
    };

    return {
      pages,
      selectedPageId,
      selectedPage,
      changeSelectedPage,
      ...handleDrawer,
    };
  },
});
export default ArticlesOverlay;
